import { ITransformationConfiguration } from '../interfaces/ITransformationComponent';

export interface ITransformationRegistry {
    constructors: Function[];
}

export class TransformationMetaModel {
    public static transformationConfigurations: ITransformationConfiguration[] = [];

    public static registry(annotation: ITransformationRegistry): ClassDecorator {
        return <TFunction extends Function>(_target: TFunction) => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            TransformationMetaModel.transformationConfigurations.push(...annotation.constructors.map((cons) => new (cons as any)()));
        };
    }
}
